import {
  NotificationConfig, NotificationType,
} from '@routific/hive';

export const getDeletingStopMessageKey = (visitId: string): string => `deleting-stop-${visitId}`;

export const deletingStopMessageFailureNotification = (message: string, retryMessage: string, retryBulkDelete?: () => void): NotificationConfig => ({
  id: 'delete-stop-failure',
  type: NotificationType.ERROR,
  message: message,
  linkMessage: retryBulkDelete ? retryMessage : undefined,
  linkOnClick: retryBulkDelete,
});
